module.exports = __webpack_public_path__ + "img/home-icon-6.b50f0f6b.png";